<div edsGrid *ngFor="let siteAlert of siteAlerts$ | async">
  <div class="container--wide">
    <div edsRow edsSpacing edsPadding edsPaddingTop="lg">
      <div edsCol>
        <eds-notifications
          [hasBorders]="true"
          [hasBorderRadius]="false"
          [hasShadows]="false"
          [hasIcon]="true"
          [inline]="false"
          [title]="siteAlert.notificationDetails.title"
          [CTAText]="null"
          [body]="siteAlert.notificationDetails.notificationLabel"
          [notificationType]="siteAlert.notificationDetails.notificationType"
          [canClose]="siteAlert.notificationDetails.canClose"
          [primaryBtnText]="siteAlert.notificationDetails.primaryBtnText"
          [secondaryBtnText]="siteAlert.notificationDetails.secondaryBtnText"
          [tertiaryBtnText]="siteAlert.notificationDetails.tertiaryBtnText"
          (closeEvent)="closeSiteAlert(siteAlert.notificationDetails)"
        >
        </eds-notifications>
      </div>
    </div>
  </div>
</div>
